<fui-rows [label]="'Venue Services'">
  <fui-content-layout-header-control slot="after">
    @if (!editing && model.canEdit()) {
      <fui-link-button [title]="'edit'"
      (click)="edit()"></fui-link-button>
    }
  </fui-content-layout-header-control>

  @if (data && formGroupServices) {
    <fui-row [formGroup]="formGroupServices">
      <fui-two-columns>
        <fui-column>
          <fui-numeric-control
            formControlName="tables"
            [control]="formGroupServices.get('tables')"
            [label]="'fhm.services.tables'"
            [placeholder]="'fhm.common.label.no-label'"
            [decimals]="0"
            [disabled]="!editing"
          [(ngModel)]="data.tables"></fui-numeric-control>
        </fui-column>
        <fui-column>
          <fui-checkbox-control
            [label]="'fhm.services.tableService'"
            [disabled]="!editing"
            [ngModelOptions]="{standalone: true}"
          [(ngModel)]="data.tableService"></fui-checkbox-control>
          <fui-checkbox-control
            [label]="'fhm.services.takeaway'"
            [disabled]="!editing"
            [ngModelOptions]="{standalone: true}"
          [(ngModel)]="data.takeaway"></fui-checkbox-control>
          <fui-checkbox-control
            [label]="'fhm.services.delivery'"
            [disabled]="!editing"
            [ngModelOptions]="{standalone: true}"
          [(ngModel)]="data.delivery"></fui-checkbox-control>
        </fui-column>
      </fui-two-columns>
    </fui-row>
    @if (allowStoreLimit && model.data.venue.deploymentStatus === CustomerInstanceVenueData.DEPLOYMENT_STATUS_READY) {
      <fui-row>
        <fui-two-columns>
          <fui-column>
            <fui-numeric-control
              [label]="'fhm.services.storeLimit'"
              [placeholder]="'fhm.common.label.no-label'"
              [decimals]="0"
              [ngModelOptions]="{standalone: true}"
              [disabled]="!editing"
            [(ngModel)]="data.storeLimit"></fui-numeric-control>
          </fui-column>
        </fui-two-columns>
      </fui-row>
    }
  }
  @if (editing && !model.draft) {
    <fui-row>
      <fhm-action-buttons>
        @if (!newEntity) {
          <fhm-remove-button [title]="'fhm.common.button.cancel'"
          (clicked)="cancelEdit()"></fhm-remove-button>
        }
        <fhm-provision-button [title]="!newEntity ? 'fhm.common.button.save' : 'fhm.common.button.create'"
        (clicked)="save()"></fhm-provision-button>
      </fhm-action-buttons>
    </fui-row>
  }
</fui-rows>
